import type { OpcoesDoFormulario } from "./tickets";

export const MIME_DE_IMAGEM = ["image/png", "image/jpeg", "image/webp"];
export const MIME_DE_VIDEO = ["video/mp4", "video/webm"];

export function megabytes(bytes: number): string {
  return `${Math.round(bytes / (1024 * 1024))} MB`;
}

/* A mesma conferência que a API repete com os bytes: aqui ela só poupa o envio de um arquivo
   que seria recusado e diz o motivo antes. O que vale é a resposta do servidor. */
export function motivoDeRecusaDoAnexo(
  arquivo: File,
  anteriores: readonly File[],
  limites: OpcoesDoFormulario["anexos"],
): string | null {
  const imagem = MIME_DE_IMAGEM.includes(arquivo.type);
  const video = MIME_DE_VIDEO.includes(arquivo.type);
  if (!imagem && !video) {
    return `${arquivo.name}: envie print (PNG, JPEG ou WebP) ou vídeo (MP4 ou WebM).`;
  }
  if (anteriores.length >= limites.maximo) {
    return `Envie no máximo ${limites.maximo} anexos.`;
  }
  if (video && anteriores.filter((item) => MIME_DE_VIDEO.includes(item.type)).length >= limites.maximo_de_videos) {
    return `Envie no máximo ${limites.maximo_de_videos} vídeos.`;
  }
  if (anteriores.reduce((soma, item) => soma + item.size, 0) + arquivo.size > limites.total_bytes) {
    return `${arquivo.name}: os anexos passariam de ${megabytes(limites.total_bytes)} no total.`;
  }
  const teto = imagem ? limites.imagem_bytes : limites.video_bytes;
  if (arquivo.size > teto) {
    return `${arquivo.name}: ${imagem ? "print" : "vídeo"} acima de ${megabytes(teto)}.`;
  }
  if (arquivo.size === 0) return `${arquivo.name}: o arquivo está vazio.`;
  return null;
}

